import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { getSearchSimoDevices, getPageCount } from 'reducers';
import { searchSimoDevices } from 'actions/simoDevices';
import SearchSimoDevices from './SearchSimoDevices';

const mapStateToProps = (state, { location: { search } }) => {
  const { page = '1' } = qs.parse(search, { ignoreQueryPrefix: true });

  return {
    simoDevices: getSearchSimoDevices(state, page),
    pageCount: getPageCount(state, 'simoDevices', `searchSimoDevices_`, page),
    page,
  };
};

const mapDispatchToProps = {
  searchSimoDevices,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchSimoDevices),
);
